var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DwHttpClient } from '../../../http/client';
import { DwAuthService } from '../../../auth/auth.service';
import { DwIamHttpErrorHandler } from './iam-http-error-handler';
import { DwUserService } from '../../../auth/user.service';
import { DwSystemConfigService } from '../../../config/config.service';
var DwIamHttpClient = /** @class */ (function (_super) {
    __extends(DwIamHttpClient, _super);
    function DwIamHttpClient(auth, systemConfig, userService, iamHttpError, dwAppAuthToken) {
        var _this = _super.call(this) || this;
        _this.auth = auth;
        _this.systemConfig = systemConfig;
        _this.userService = userService;
        _this.iamHttpError = iamHttpError;
        _this.dwAppAuthToken = dwAppAuthToken;
        _this.systemConfig.get('iamUrl').subscribe(function (url) { return _this.api = url; });
        return _this;
    }
    Object.defineProperty(DwIamHttpClient.prototype, "defaultHeaders", {
        get: function () {
            var token = this.userService.getUser('token') ? this.userService.getUser('token') : '';
            return {
                'digi-middleware-auth-app': this.dwAppAuthToken,
                'digi-middleware-auth-user': token
            };
        },
        enumerable: true,
        configurable: true
    });
    DwIamHttpClient.prototype.errorHandler = function (event) {
        if (event.error && event.error.message) {
            this.iamHttpError.handlerError(event);
        }
    };
    return DwIamHttpClient;
}(DwHttpClient));
export { DwIamHttpClient };
